var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMutedMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6671 29.2444V15.5555C46.6671 10.4008 42.4884 6.22217 37.3338 6.22217C33.6701 6.22217 30.4994 8.33312 28.9717 11.4051M37.3338 59.1111V68.4444M37.3338 59.1111C25.3062 59.1111 15.556 49.3608 15.556 37.3333V31.1111M37.3338 59.1111C49.3613 59.1111 59.1115 49.3608 59.1115 37.3333V31.1111M24.8893 68.4444H49.7782M6.22266 6.22217L68.4449 68.4444M37.3338 46.6666C32.1791 46.6666 28.0004 42.4879 28.0004 37.3333V27.9999L43.9374 43.9289C42.2481 45.6203 39.9131 46.6666 37.3338 46.6666Z",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutedMic);
export default __webpack_public_path__ + "static/media/mutedMic.62a54ecc6872e93e2f5636f672805bd0.svg";
export { ForwardRef as ReactComponent };